import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={23.999}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 680000 634970"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="XMLID_1_">
        <path
          id="XMLID_2_"
          d="M516500 69640h-46420V0H47390v563310H0v71660h359810v-71660H88020V40620h341440v29020h-46430v48360h-46160v258790h49770V118000h8910v258790h49770V118000h8900v258790h49770V118000h8900v258790h49770V118000h-46160z"
          className="fil0"
        />
        <path
          id="XMLID_65_"
          d="M219530 118002h49762v258785h-49762z"
          className="fil0"
        />
        <path
          id="XMLID_69_"
          d="M278201 118002h49768v258785h-49768z"
          className="fil0"
        />
        <path
          id="XMLID_85_"
          d="M571561 118002h49762v258785h-49762z"
          className="fil0"
        />
        <path
          id="XMLID_97_"
          d="M630238 118002h49762v258785h-49762z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
